import { render, staticRenderFns } from "./AuthInfoForPeople.vue?vue&type=template&id=29cebc66&scoped=true&"
import script from "./AuthInfoForPeople.vue?vue&type=script&lang=js&"
export * from "./AuthInfoForPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cebc66",
  null
  
)

export default component.exports